import { render, staticRenderFns } from "./viewStaff.vue?vue&type=template&id=a993f1c0&scoped=true&"
import script from "./viewStaff.vue?vue&type=script&lang=js&"
export * from "./viewStaff.vue?vue&type=script&lang=js&"
import style0 from "./viewStaff.vue?vue&type=style&index=0&id=a993f1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a993f1c0",
  null
  
)

export default component.exports